import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reassign-owner",
  "use": "icon-reassign-owner-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-reassign-owner\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.809 3.412a1 1 0 1 0-1.618 1.176L19.036 8.5H4a1 1 0 0 0 0 2h15.036c1.635 0 2.58-1.854 1.618-3.176l-2.845-3.912ZM6.19 20.088a1 1 0 0 0 1.618-1.176L4.964 15H20a1 1 0 1 0 0-2H4.964c-1.635 0-2.58 1.854-1.618 3.176l2.845 3.912Z\" fill=\"#4066D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol